require('./bootstrap');

import Alpine from 'alpinejs';

window.Alpine = Alpine;

import editResource from "./resources/edit.js";
import calculate from "./resources/calculate";

Alpine.data('editResource', editResource)

Alpine.data('calculatePricing', calculate)

Alpine.start();

(function($) {

})(jQuery);
